module.exports = "span.required.invalid{color:red !important}\n"